import { Icon } from "@/components/site/Icon";
import { SectionHeading } from "@/components/site/ui";
import { useFetch } from "@/lib/useFetch";

export function WhyGrid() {
    const { data: why } = useFetch("/why", []);
    return (
        <section className="bg-teal-800 py-20 grain" data-testid="why-section">
            <div className="container-x">
                <div className="mb-12 text-center flex flex-col items-center">
                    <SectionHeading center eyebrow="Why Sudigi" title="Why Businesses Choose Sudigi" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {(why || []).map((w) => (
                        <div key={w.title} className="card-teal rounded-2xl p-6" data-testid={`why-${w.title.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                            <div className="w-12 h-12 rounded-xl bg-growth/15 border border-growth/30 flex items-center justify-center">
                                <Icon name={w.icon} className="w-6 h-6 text-growth" />
                            </div>
                            <h3 className="mt-4 font-bold text-cream text-lg">{w.title}</h3>
                            <p className="mt-2 text-sm text-cream-soft">{w.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
